import { render } from "./map-tab-nbr.vue?vue&type=template&id=8a92beb4"
import script from "./map-tab-nbr.vue?vue&type=script&lang=js"
export * from "./map-tab-nbr.vue?vue&type=script&lang=js"

import "./map-tab-nbr.vue?vue&type=style&index=0&id=8a92beb4&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-map/classic/map-tab-nbr.vue'],['render',render],['__file',"map-tab-nbr.vue"]])

export default __exports__